import { jsx as _jsx } from "react/jsx-runtime";
import { skipToken } from '@reduxjs/toolkit/query';
import { useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { useParams, useHistory, useLocation, useRouteMatch, } from 'react-router-dom';
import { compose } from 'redux';
import { Spinner, QUERY_KEY, STORE_LINK_CAMPAIGN_COOKIE_OPTIONS, parseQuery, reportAction, } from 'shared';
import { useGetConsumerApplicationsV1LocationsSearchQuery } from 'consumer-applications-v1-api';
import { toastError } from 'utils';
import * as actions from '../actions';
import { selectors } from '../reducer';
import { Wizard } from '.';
function StoreLookup({ setPractice, practice }) {
    const { id: rawId } = useParams();
    const history = useHistory();
    const { search } = useLocation();
    const match = useRouteMatch();
    const queryParams = parseQuery(search);
    const lookupType = match?.path.includes('location') ? 'location' : 'store';
    // Extract only the numeric part from the id parameter (remove query string if present)
    const id = rawId?.split('?')[0];
    const storeLinkCampaign = useRef(queryParams[QUERY_KEY.STORE_LINK_CAMPAIGN]);
    const otlRef = useRef(queryParams[QUERY_KEY.OTL]);
    const [, setCookie] = useCookies(['storeLinkCampaign']);
    const { data: practiceRes, isError: isErrorFetchingPractice } = useGetConsumerApplicationsV1LocationsSearchQuery(id && lookupType === 'location'
        ? { locationId: Number(id) }
        : id && lookupType === 'store'
            ? { adsStoreNumber: Number(id) }
            : skipToken);
    useEffect(() => {
        if (practiceRes && practiceRes.locationId) {
            setPractice(practiceRes);
        }
    }, [practiceRes]);
    useEffect(() => {
        if (practice && storeLinkCampaign.current && otlRef.current) {
            setCookie('storeLinkCampaign', {
                campaignId: storeLinkCampaign.current,
                storeId: practice?.adsStoreNumber,
                otl: otlRef.current,
            }, STORE_LINK_CAMPAIGN_COOKIE_OPTIONS);
        }
    }, [practice, storeLinkCampaign.current, otlRef.current, setCookie]);
    useEffect(() => {
        if (isErrorFetchingPractice) {
            toastError('Practice Not Found!');
            history.push('/');
        }
    }, [isErrorFetchingPractice]);
    useEffect(() => {
        if (id) {
            reportAction('StoreLookup', {
                componentName: 'StoreLookup',
                actionType: 'LocationSearch',
                actionURL: window.location.pathname,
                actionData: {
                    id,
                    lookupType,
                    routePath: match?.path,
                    windowPathname: window.location.pathname,
                    referrer: document.referrer.split('?')[0],
                    hasOtl: Boolean(otlRef.current),
                    hasStoreLinkCampaign: Boolean(storeLinkCampaign.current),
                },
            });
        }
    }, [id, lookupType, match?.path]);
    if (practice) {
        return _jsx(Wizard, {});
    }
    else {
        return _jsx(Spinner, { centerPage: true });
    }
}
function mapStateToProps(state) {
    return {
        practice: selectors.practice(state),
    };
}
const mapDispatchToProps = {
    setPractice: actions.setPractice,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(StoreLookup);
